module.exports = __webpack_public_path__ + "sino.png?2745e12c5ace6750da20b31e2595f779";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/sino.png
// module id = 224
// module chunks = 0